import React from 'react';
import Carousel from '../ui/carousel';

const StudentSection = () => {

  return (
    <div className="!mt-14 flex flex-col gap-8 md:gap-10 ">
       {/* NTA Section */}
       <div className="flex flex-row items-center justify-center gap-4 md:gap-6">
        <p className="fredokaOne text-left text-[16px] md:text-[20px] leading-snug tracking-[-0.5px] text-[#012E33] max-w-[600px]">
          <a
            href="https://ntatutor.com"
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-blue-600 hover:text-blue-800"
          >
            Proud Member of the National Tutor Association
          </a>
        </p>
        <img
          src="/images/home/NationalTutorAssociation-Logo.jpg"
          className="h-[50px] md:h-[70px] object-contain"
          alt="National Tutor Association Logo"
        />
        
      </div>

      {/* Divider Line */}
      <div className="w-full border-t border-[#dcdcdc] my-4 md:my-6"></div>

      {/* Trusted By Section */}
      <h1 className="fredokaOne mx-auto w-[342px] text-center text-[40px] leading-normal tracking-[-0.8px] text-[#012E33] md:w-full">
        Trusted by students at
      </h1>

      <p className="fredokaOne mx-auto text-center text-[16px] md:text-[20px] leading-snug tracking-[-0.5px] text-[#012E33] max-w-[600px]">
        Our tutors have guided students attending prestigious institutions.
      </p>

      <Carousel className={'flex justify-between !gap-14'}>
        <img src="/uni/kss.png" className="h-[90px] flex-none object-contain md:w-[90px]" alt="" />
        <img src="/uni/uni.png" className="h-[90px] flex-none object-contain md:w-[90px]" alt="" />
        <img
          src="/uni/uni-2.png"
          className="h-[90px] flex-none object-contain md:w-[90px]"
          alt=""
        />
        <img
          src="/uni/rice-university.png"
          className="h-[90px] flex-none object-contain md:w-[90px]"
          alt=""
        />
        <img
          src="/uni/texas-logo.png"
          className="h-[90px] flex-none object-contain md:w-[90px]"
          alt=""
        />
        <img
          src="/uni/StrakeJeb.png"
          className="h-[90px] flex-none object-contain md:w-[90px]"
          alt=""
        />
        <img src="/uni/sjs.png" className="h-[90px] flex-none object-contain md:w-[90px]" alt="" />
        <img
          src="/uni/stagnes-mascot.png"
          className="h-[90px] flex-none object-contain md:w-[90px]"
          alt=""
        />
        <img src="/uni/kss.png" className="h-[90px] flex-none object-contain md:w-[90px]" alt="" />
        <img src="/uni/uni.png" className="h-[90px] flex-none object-contain md:w-[90px]" alt="" />
        <img
          src="/uni/uni-2.png"
          className="h-[90px] flex-none object-contain md:w-[90px]"
          alt=""
        />
        <img
          src="/uni/rice-university.png"
          className="h-[90px] flex-none object-contain md:w-[90px]"
          alt=""
        />
        <img
          src="/uni/texas-logo.png"
          className="h-[90px] flex-none object-contain md:w-[90px]"
          alt=""
        />
        <img
          src="/uni/StrakeJeb.png"
          className="h-[90px] flex-none object-contain md:w-[90px]"
          alt=""
        />
        <img src="/uni/sjs.png" className="h-[90px] flex-none object-contain md:w-[90px]" alt="" />
        <img
          src="/uni/stagnes-mascot.png"
          className="h-[90px] flex-none object-contain md:w-[90px]"
          alt=""
        />
      </Carousel>
    </div>
  );
};

export default StudentSection;
